import React, { useState } from "react";
import { Button, Modal } from "react-bootstrap";
import { useDispatch } from "react-redux";
import workApi from "../../data/api/workApi";
import NewWorkModal from "../modals/newWorkModal";
import NewClientModal from "../modals/NewClientModal";
import CreateUserModal from "./usersPage/CreateUserModal";
import useUsersPageController from "./usersPage/useUsersPageController";

export default function useDashboardCreation({
  isCompany,
  isAdmin,
  parties,
  t
}) {
  const dispatch = useDispatch();
  const [showWork, setShowWork] = useState(false);
  const [showClient, setShowClient] = useState(false);
  const [returnToWork, setReturnToWork] = useState(false);
  const [name, setName] = useState("");
  const [partyId, setPartyId] = useState("");
  const userCreation = useUsersPageController({
    enabled: isCompany,
    onCreated: (user) => {
      if (returnToWork) {
        setPartyId(String(user.userId));
        setShowWork(true);
        setReturnToWork(false);
      }
    }
  });
  const openParty = (fromWork = false) => {
    setReturnToWork(fromWork);
    if (fromWork) setShowWork(false);
    if (isCompany) userCreation.openCreate();
    else setShowClient(true);
  };
  const closeParty = () => {
    setShowClient(false);
    userCreation.closeCreate();
    if (returnToWork) setShowWork(true);
    setReturnToWork(false);
  };
  const actions = (
    <div
      className="dashboard-create-actions"
      onClick={(event) => event.stopPropagation()}
    >
      <Button
        onClick={() => {
          setName("");
          setPartyId("");
          setShowWork(true);
        }}
      >
        {t("createWork")}
      </Button>
      <Button variant="outline-primary" onClick={() => openParty()}>
        {t(isCompany ? "createCarpenter" : "createClient")}
      </Button>
    </div>
  );
  const modals = (
    <>
      <Modal show={showWork} onHide={() => setShowWork(false)} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("createWork")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewWorkModal
            handleClose={() => setShowWork(false)}
            onSubmit={(work) => dispatch(workApi.createWorkApi(work))}
            parties={parties.map((party) => ({
              id: party.clientId,
              name: party.name,
              workCount: party.workCount,
              carpenterName: party.carpenterName
            }))}
            isCompany={isCompany}
            isAdmin={isAdmin}
            partyId={partyId}
            onPartyChange={setPartyId}
            onAddParty={() => openParty(true)}
            name={name}
            onNameChange={setName}
          />
        </Modal.Body>
      </Modal>
      <Modal show={showClient} onHide={closeParty} centered>
        <Modal.Header closeButton>
          <Modal.Title>{t("createClient")}</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          <NewClientModal
            onClose={closeParty}
            onCreated={(client) => {
              if (returnToWork) setPartyId(String(client.clientId));
            }}
          />
        </Modal.Body>
      </Modal>
      <CreateUserModal
        show={userCreation.showCreate}
        creating={userCreation.creating}
        error={userCreation.createErr}
        form={userCreation.createForm}
        t={t}
        title={t("createCarpenter")}
        onClose={closeParty}
        onChange={userCreation.handleCreateChange}
        onSubmit={userCreation.handleCreateUser}
      />
    </>
  );
  return { actions, modals };
}
